module.exports = __webpack_public_path__ + "img/4.3b88141d.png";